import { Button, Form, notification, Popconfirm } from "antd";
import React, { useState } from "react";
import { addNewFeature } from "../action";
import { MultiLanguageInput } from "../../../Components/MultiLanguageInput";
import { PiPlus } from "react-icons/pi";

type Props = {
  fetchData: () => void;
};

interface FormValues {
  feature: {
    en: string;
    ar: string;
    fr: string;
  };
}

const AddNewFeature: React.FC<Props> = ({ fetchData }) => {
  const [form] = Form.useForm<FormValues>();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const formValues = await form.validateFields();
      setIsLoading(true);

      const data = await addNewFeature(formValues.feature);

      if (data) {
        form.resetFields();
        fetchData();
        api.success({
          message: "Feature added successfully",
        });
      }
    } catch (err: any) {
      api.error({
        message: "Failed to add feature",
        description:
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Unexpected error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form form={form} layout="vertical">
      {contextHolder}

      <MultiLanguageInput name="feature" label="Feature" />

      <Form.Item shouldUpdate>
        {() => (
          <Popconfirm
            title="Are you sure you want to add this feature?"
            onConfirm={handleSubmit}
            okText="Yes"
            cancelText="No"
          >
            <Button
              icon={<PiPlus />}
              loading={isLoading}
              type="primary"
              className="w-full"
              disabled={
                !form.isFieldsTouched(true) ||
                form.getFieldsError().some(({ errors }) => errors.length > 0)
              }
            >
              {isLoading ? "Adding Feature..." : "Add Feature"}
            </Button>
          </Popconfirm>
        )}
      </Form.Item>
    </Form>
  );
};

export default AddNewFeature;
